import { Query, QueryKey } from "@tanstack/react-query";
import { AxiosError } from "axios";

const handleUnauthorized = (
  error: Error,
  query: Query<unknown, unknown, unknown, QueryKey>,
) => {
  if (
    !query.queryKey.includes("user") &&
    (error as AxiosError)?.response?.status === 401 &&
    location.pathname !== "/auth/login"
  ) {
    localStorage.clear();
    const currentPath = location.pathname + location.search;
    location.replace(`/auth/login?redirect=${encodeURIComponent(currentPath)}`);
  }
};
export default handleUnauthorized;
